import { memo, useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";
import { GTextareaCom, Input } from "../../../../Components/AllInput/AllInput";
import ReactSelect from "../../../../Components/New/Select/ReactSelect";
import { ProjectTy } from "../../../../ReduxTool/Slice/Auth/types";
import { getStateDiscom, getTerrifData } from "../../../../ReduxTool/Slice/CommonReducers/CommonActions";
import { IallTypestate, ITariffType } from "../../../../ReduxTool/Slice/CommonReducers/types";
import { patchFormProjectSetup, resetDirtyAddress, setCountryName, setCreatedId, setFormProjectSetup, setIsSubAccordianCompletedStep, setOndFiles, setProject3dAnalysisIframeURL, setProjectName, setRegionName, setRoofDetailsError } from "../../../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { getDistrictListByStateID, getStateListByCountryID, setDistrictNameByStateID } from "../../../../ReduxTool/Slice/GeneralSlice/CountrySlice";
import { districtNameResponseTy, stateNameResponseTy } from "../../../../ReduxTool/Slice/GeneralSlice/type";
import { setIs3DData, setIsBuildingDrawn, toogleTooltip } from "../../../../ReduxTool/Slice/Map/MapReducer";
import { useAppDispatch, useAppSelector } from "../../../../ReduxTool/store/hooks";
import { FORMTOASTERRID, GridTypeOption, INSTALLATION_MODE, MAXUSEABLEAREA, MINUSEABLEAREA, RoofType } from "../../../../Utils/Const";
import globalLayers from "../../../../Utils/CustomerMaps/Maps/GlobaLMap";
import { fetchCompleteAddress, fetchCountryNamefromLatLng, getCityFromCoordinates, getStateFromCoordinates } from "../../../../Utils/CustomerMaps/Maps/LazyloadMap";
import { fetch3dData } from "../../../../Utils/Fetch3D/fetch3d";
import { capitalizedWordOfSentence, capitalizeFirstLetter, capitalizeFirstLetterOnly, capitalizeFirstWord, convertACtoDC, filterKeyIncludeArr, getCapacityFields, generateProjectName, getElementByIndex, isEstimateCurrent, newgeneratedId, useDebounce } from "../../../../Utils/commonFunctions";
import { ArrowRightIcon, BackBoxIcon, EditIcon, HourglassIcon, InfoMark, LocationIcon, SolarPowerIcon, TrendingUpIcon } from "../../../../assests/icons/Icons";
import { Button } from "../../../../Components/Button";
import { IconSave } from "../../../../assests/icons/MapToolsIcons";
import { Accordion } from "../NewSiteAnalyze";
import { setButtonLoader, setModalHeaderFooter } from "../../../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { NewModal } from "../../../../Components/New/Modal/NewModal";
import RoofDetails, { getMaxConnectedLoad } from "../RoofDetails/RoofDetails";
import { SolarSummaryContent } from "../RoofAnalysisExtras/SolarSummaryExtras";
import Toast from "../../../../Components/ErrorBoundry/Toast";
import { setUserProjects } from "../../../../ReduxTool/Slice/Auth/AuthReducer";
import { saveConsumerProjects } from "../../../../ReduxTool/Slice/Consumer/ProjectServices/projectServices";
import { fetchPANOND } from "../../../../ReduxTool/Slice/Consumer/ConsumerActions";
import SolarSummary from "../SolarSummary/SolarSummary";
import ReactTooltip from "../../../../Components/ReactTooltip/ReactTooltip";
import { switchView } from "../../../../lib/Customer/SwitchMap";
import { fetchBuildingfromCoordinates } from "../../../../Utils/Fetch3D/fetchRoof";
import { baseURL, EPCRoofAnalysisURLString, requestUrl } from "../../../../Utils/baseUrls";
import { ProgressStepper, ProposalStep } from "../../../../Components/Stepper/ProgressStepper";
import { GInfoCard } from "../../../../Components/Card/NewInfoCard";
import { SubAccordionCompletedStep, TProjectTypesNew } from "../../../../ReduxTool/Slice/Consumer/types";
import Graphic from "@arcgis/core/Graphic";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import { countryJsonType } from "../../../../ReduxTool/Slice/Auth/types";
import { findCountryMaster, loadCountryMaster, normalizeCountryPostalInput, postalInputMaxLength, validateCountryPostalCode } from "../../../../Utils/countryMaster";

export type projectSetupAddress = { city: string; state: string; country: string; pincode: string; addressline1: string; }

const normalizeLocationName = (value?: string | null) =>
  (value ?? "").normalize("NFKD").toLocaleLowerCase().replace(/[\s.'’-]/g, "");

const locationInitials = (value: string) =>
  value.trim().split(/\s+/).map(part => part[0] ?? "").join("").toLocaleLowerCase();

export type btnTitleTypeCustomer = 'Project Summary' | 'Proceed' | 'Quick Plant Analysis' | "Site Details"
export const computeCapacity = (useableArea: number) => {
  const module = { length: 1.816, width: 1.068, stc: 560 }
  // const useableArea = (projectSetup?.useablearea || 0 > 0) ? +projectSetup?.useablearea?.toFixed(2) : +projectSetup?.totalroofarea?.toFixed(2)
  if (!useableArea) return 0;

  const moduleArea = module.length * module.width;
  const modulePower = module.stc;

  // Calculate number of modules and total capacity in kW
  const moduleNo = useableArea / moduleArea;
  const capacity = (moduleNo * modulePower) / 1000;

  return Math.round(capacity); // .toFixed(0) and parseInt is same as Math.round
};

const MAX_UNIT_PER_KW = 165;
const MAX_MONTHLY_UNIT = 15000;
const MAX_ROOF_AREA = 50000;
const MAXDCTOACCONVERTRATIO = 0.85; // 0.85 (85%) → safe & realistic {By chatgpt}

// export const getStateCityPincodeByLatLong = async (lat: any, lng: any)=>{
//   try {
//     const res = await baseURL.get(`${requestUrl.getStateByLatLong}//`);
//     if(res.status === 200){
//       // debugger;
//       return res?.data?.responseData ;
//     }
//   } catch (error) {
//     toast.error("Failed to get state, city and pincode.",{autoClose: 7000});
//   }
// }


/** True for a real map point; the form's initial 0,0 (or a missing/NaN coordinate) is not one. */
const hasSiteCoordinates = (lat: unknown, lng: unknown) =>
  Number.isFinite(Number(lat)) && Number.isFinite(Number(lng)) && Number(lat) !== 0 && Number(lng) !== 0;

const SiteAddress = ({ isLoading, setIsLoading }: { isLoading?: boolean, setIsLoading?: (arg: boolean) => void }) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(state => state.auth);
  const { title, btnTxt, modalid } = useAppSelector((state) => state.commonReducers.modal);
  const { statesList, districtsList } = useAppSelector((state) => state.CountrySlice);
  const { roofAnalysis: { formDetails: { projectSetup: { lat, lng, address }, projectSetup, error, quickplantAnalysis }, selected_project, isWithRoof, useableArea, obsArea, countryName, regionName, isSubAccordianCompletedStep, selected_project_index } } = useAppSelector(state => state.consumerReducers);
  const { allDiscom, providertype, buttonLoader } = useAppSelector((state) => state.commonReducers);
  const { user: { projects } } = useAppSelector(state => state.auth);
  const { polygonDrawn } = useAppSelector((state) => state.drawer);
  const { is3ddata } = useAppSelector((state) => state.mapref);
  const [countries, setCountries] = useState<countryJsonType[]>([]);
  useEffect(() => {
    let mounted = true;
    loadCountryMaster().then(data => { if (mounted) setCountries(data); }).catch(() => {});
    return () => { mounted = false; };
  }, []);
  const siteCountry = findCountryMaster(countries, projectSetup.country || countryName) ??
    (user?.country_mstr?.countryname === (projectSetup.country || countryName) ? user.country_mstr : undefined);
  const checkPinLength = postalInputMaxLength(siteCountry);
  const { is3dpayment } = useAppSelector(state => state.payment)
  const [analysisConfirm, setAnalysisConfirm] = useState(false);
  const [isAnalysis, setIsAnalysis] = useState(false);
  const [isIndiaAddressAutoPopulated, setIsIndiaAddressAutoPopulated] = useState(false);
  const [addressLoading, setAddressLoading] = useState(true);
  const [addressModalBtnLoading, setAddressModalBtnLoading] = useState(false);
  const addressSavingRef = useRef(false);
  const creatingProjectRef = useRef(false);
  const createdProjectIdRef = useRef("");

  const lastApiParams = useRef<{ stName: string | null, providerId: string | null, stateId: string | null }>({ stName: null, providerId: null, stateId: null });
  // Set right before the "Get Estimate" save so the resulting selected_project update
  // doesn't re-trigger the discom/tariff-category fetch — that data isn't needed to show the estimate.
  const skipTariffFetchRef = useRef(false);
  const bindInitialDataId = useRef(0);

  let currentStepRef = useRef<ProposalStep | null>(1);
  const [currentStep, setCurrentStep] = useState<ProposalStep>(1);
  const [completedStep, setCompletedStep] = useState(0);
  const [saveButtonLoading, setSaveButtonLoading] = useState(false)
  const projectSetupSnapshot = useRef<null | { city: string, state: string, country: string, pincode: string, addressline1: string }>(null);
  const addressEditRevision = useRef(0);
  const lastAutofilledLocation = useRef("");
  const projectSetupUpdated = useRef<boolean>(true)  // !Important Ref 
  const initialFormState = useRef(JSON.stringify(projectSetup));
  const roofDetailsModalTimeOutRef = useRef<NodeJS.Timeout | null>(null);

  // console.log("Current step ",selected_project?.consumer_subprojectstatus)
  // debugger
  useEffect(() => {
    const subStatus = selected_project?.consumer_subprojectstatus ?? 0;
    if (subStatus >= 2) {
      currentStepRef.current = 4
      setCurrentStep(4);
      dispatch(setIsSubAccordianCompletedStep(3))
      setCompletedStep(3);
    } else {

      const restoredStep = (currentStepRef.current && currentStepRef.current > 1) ? currentStepRef.current : 1;
      setCurrentStep(restoredStep as ProposalStep);
      // Only reset completed steps if it's a brand new project
      if (subStatus === 0) {
        dispatch(setIsSubAccordianCompletedStep(0));
        setCompletedStep(0);
      }
    }

    if (currentStepRef.current === 3) {
      setCurrentStep(3);
      dispatch(setIsSubAccordianCompletedStep(2))
      setCompletedStep(2);
    }
    if (currentStepRef.current === 2) {
      setCurrentStep(2);
      dispatch(setIsSubAccordianCompletedStep(1))
      setCompletedStep(1);
    }

    // --- THE CLEANUP FUNCTION ---
    // return () => {
    //   // This runs when SiteAddress unmounts
    //   console.log("Cleaning up SiteAddress refs...");

    //   // Resetting current step so it doesn't "leak" into the next project
    //   currentStepRef.current = 1; 

    //   // Nullify the snapshot to ensure no stale 'undo' data exists
    //   projectSetupSnapshot.current = null;

    //   // Optional: If you use any event listeners or intervals, clear them here
    // };

  }, [selected_project?.projectid]);

  useEffect(() => {
    if (modalid === "roofdetails") {
      // setCurrentStep((completedStep + 1 > 4 ? 4 : completedStep + 1) as ProposalStep);
    }
  }, [modalid]);

  useEffect(() => {
    !selected_project && selected_project_index === null && bindInitalData()
  }, [lat, lng]);

  useEffect(() => {
    if (selected_project && selected_project.projectid) {
      const getRoofDetails = async () => {
        // const data = await fetch3dData(selected_project?.lat, selected_project?.lng);
        // if (data !== null && data !== undefined) { dispatch(setIs3DData(true)) }
        // else { dispatch(setIs3DData(false)) }
      }
      getRoofDetails();

      try {
        bindProjectSetupData(selected_project).then(() => {
          if (globalLayers.LocationMarkerPointGraphic instanceof Graphic) {
            (globalLayers.sketchViewModel as SketchViewModel)?.layer.graphics.remove(globalLayers.LocationMarkerPointGraphic);
          }

        })

      } catch (error) {
        console.log(error)
      }

    }
  }, [selected_project]);

  useEffect(() => {
    if (roofDetailsModalTimeOutRef.current) {
      clearTimeout(roofDetailsModalTimeOutRef.current);
    }
  }, [])

  // const hasCheckedProjectRef = useRef(false);
  // const autoOpenAddressRef = useRef(false);

  // useEffect(() => {
  //   // wait until selected_project is resolved once
  //   if (!hasCheckedProjectRef.current) {
  //     if (selected_project === undefined) return; // still loading
  //     hasCheckedProjectRef.current = true;
  //   }

  //   // open only if project truly doesn't exist
  //   if (!selected_project && !autoOpenAddressRef.current) {
  //     autoOpenAddressRef.current = true;

  //     dispatch(
  //       setModalHeaderFooter({
  //         title: "Site Address",
  //         btnTxt: "Save Address",
  //         secondaryBtnTxt: "Back",
  //         modalid: "siteaddress",
  //       })
  //     );

  //     setAddressEditModal({
  //       editAddress: true,
  //       message: "",
  //       success: false,
  //     });
  //   }
  // }, [selected_project]);

  // ------------------------------------------------------

  // add auto state, city/district, pincode from api getStateCityPincodeByLatLong,
  // if  user?.country_mstr?.countryname === "India" otherwise every thing work as it and populate in  -> input's and disabled inputs{make redux key if needed in projectSetup} modalid === "siteaddress" , 
  // prevent api call unnessesary on rerender or more cal on only lat long changes 



  const getStateCityPincodeByLatLong = async (lat: any, lng: any) => {
    // The form starts at 0,0 before a point is picked; the API answers that with the nearest pincode (Kachchh, Gujarat)
    if (!hasSiteCoordinates(lat, lng)) return null;
    try {
      const res = await baseURL.get(`${requestUrl.getStateByLatLong}/${lat}/${lng}`);
      if (res.status === 200) {
        return res?.data?.responseData;
      }
    } catch (error) {
      toast.error("Failed to get state, city and pincode.", { autoClose: 7000 });
    }
  }

  const projectSetupRef = useRef<TProjectTypesNew | null>(projectSetup);
  useEffect(() => {
    projectSetupRef.current = projectSetup
    projectSetupUpdated.current = true
  }, [projectSetup]);

  useEffect(() => {
    if (selected_project && user?.country_mstr?.countryname === "India" && lat && lng && (selected_project?.consumer_subprojectstatus ?? 0) < 3) {
      const fetchIndiaData = async () => {
        const data = await getStateCityPincodeByLatLong(lat, lng);
        if (data) {
          if (data.stateid) {
            dispatch(getDistrictListByStateID([data.stateid]));
          }
          if (projectSetupRef.current === null) return;
          dispatch(setFormProjectSetup({ ...projectSetupRef.current, state: data.state, city: data.district, pincode: data.pincode }));
        }
      };
      fetchIndiaData();
    }

    return () => {
      projectSetupRef.current = null;
    }
  }, [lat, lng])

  useEffect(() => {
    if ((modalid !== "siteaddress" && modalid !== "siteaddressback") || !lat || !lng) return;
    if (selected_project && selected_project.lat === lat && selected_project.lng === lng) return;

    const locationKey = `${selected_project?.projectid ?? projectSetup.createdId ?? "new"}:${lat},${lng}`;
    if (lastAutofilledLocation.current === locationKey) return;

    let cancelled = false;
    const editRevision = addressEditRevision.current;

    const autofillAddress = async () => {
      const geocoded = await fetchCompleteAddress(lat, lng);
      if (cancelled || !geocoded) return;

      const countryList = await loadCountryMaster();
      const country = findCountryMaster(countryList, geocoded.countryAbbr) ??
        findCountryMaster(countryList, geocoded.country);
      if (!country || !["AU", "AE", "OM"].includes(country.alpha2code?.toUpperCase())) return;
      if (cancelled || addressEditRevision.current !== editRevision) return;

      const stateResult = await dispatch(getStateListByCountryID(country.countryid)).unwrap();
      const states: stateNameResponseTy[] = Array.isArray(stateResult) ? stateResult : [];
      const region = normalizeLocationName(geocoded.state);
      const regionAbbr = normalizeLocationName(geocoded.regionAbbr);
      const matchedState = states.find(state =>
        normalizeLocationName(state.state) === region ||
        (regionAbbr && (normalizeLocationName(state.state) === regionAbbr ||
          locationInitials(state.state) === regionAbbr))
      );

      let matchedCity: districtNameResponseTy | undefined;
      if (matchedState) {
        if (cancelled || addressEditRevision.current !== editRevision) return;
        const districtResult = await dispatch(getDistrictListByStateID([matchedState.stateid])).unwrap();
        const districts: districtNameResponseTy[] = Array.isArray(districtResult) ? districtResult : [];
        matchedCity = [geocoded.district, geocoded.city]
          .filter(Boolean)
          .map((name: string) => districts.find(district =>
            normalizeLocationName(district.district) === normalizeLocationName(name)))
          .find(Boolean);
      }

      if (cancelled || addressEditRevision.current !== editRevision) return;
      if (!matchedState) dispatch(setDistrictNameByStateID([]));
      // Providers were loaded from the map's region name, which can be in the local language; reload with ours
      if (matchedState && lastApiParams.current.stName !== matchedState.state) {
        lastApiParams.current.stName = matchedState.state;
        dispatch(getStateDiscom(matchedState.state));
      }

      const postalCode = String(geocoded.pincode ?? "").trim();
      dispatch(patchFormProjectSetup({
        country: country.countryname,
        state: matchedState?.state ?? "",
        city: matchedCity?.district ?? "",
        pincode: validateCountryPostalCode(postalCode, country)
          ? ""
          : normalizeCountryPostalInput(postalCode, country),
      }));
      lastAutofilledLocation.current = locationKey;
    };

    autofillAddress().catch(() => {
      // Preserve entered values when geocoding or location lists are unavailable.
    });
    return () => { cancelled = true; };
  }, [lat, lng, modalid, selected_project?.projectid, projectSetup.createdId, dispatch]);

  // -----------------------------------------------------

  // }, [selected_project]); // try to fix rerendring 

  // useEffect(() => {
  //   if (selected_project && selected_project.projectid) {
  //     debugger
  //     bindProjectSetupData(selected_project);   
  //     const getRoofDetails = async ()=>{
  //     if(!selected_project.graphicLayer){
  //       const data = await fetch3dData(selected_project?.lat, selected_project?.lng);
  //       if(data !== null && data !== undefined){dispatch(setIs3DData(true))}
  //     }
  //     else{dispatch(setIs3DData(false))}}
  //     getRoofDetails();
  //   }
  // }, [selected_project]);



  const [show, hide] = useState(false)

  const fetchIframeAnalysis = async () => {
    setIsAnalysis(true)
    if (show) {
      await switchView(globalLayers.activeView)
      return
    }
    const building = await fetchBuildingfromCoordinates(selected_project?.lat as number, selected_project?.lng as number, selected_project?.graphicLayer);
    if (building) {
      const token = localStorage.getItem("token");
      // const url = `/Consumer/RoofAnalysis?token=&userid=${user.userid}&projectid=${(selected_project as ProjectTy)?.buildingid}`;
      const url = `${EPCRoofAnalysisURLString}/Consumer/RoofAnalysis?token=${token}&userid=${user.userid}&projectid=${(selected_project as ProjectTy)?.buildingid}`;
      dispatch(setProject3dAnalysisIframeURL(url))
      // window.open(url, '_blank');
    } else {
      Toast({ messageText: 'No, 3D roof availabe here', messageType: 'W', toastId: '3d-fecth', autoClose: 3500 })
    }
    setIsAnalysis(false)
    setAnalysisConfirm(false)
    return
  }

  const bindInitalData = async () => {
    // A newer point may be picked while this one is still resolving; only the latest may write to the form
    const bindId = ++bindInitialDataId.current;
    // Runs on mount too, before any point is picked (lat/lng 0): nothing to look up yet
    if (!hasSiteCoordinates(lat, lng)) return;
    setAddressLoading(true);
    let stName = await getStateFromCoordinates(lng, lat);
    let countryName = await fetchCountryNamefromLatLng(lat, lng);
    let indiaData = null;
    const isIndia = user?.country_mstr?.countryname === "India";

    if (isIndia) {
      indiaData = await getStateCityPincodeByLatLong(lat, lng);
      if (bindId !== bindInitialDataId.current) return;
      if (indiaData) {
        setIsIndiaAddressAutoPopulated(true);
        stName = indiaData.state;
        countryName = indiaData.countryname || countryName;
        if (indiaData.stateid) dispatch(getDistrictListByStateID([indiaData.stateid]));
      } else {
        setIsIndiaAddressAutoPopulated(false);
      }
    } else {
      setIsIndiaAddressAutoPopulated(false);
    }

    if (bindId !== bindInitialDataId.current) return;
    // Use this point's state only: projectSetup.state here still holds the previous site's state (e.g. Gujarat
    // while drawing in Noida). AU/AE/OM regions can be in the local language; the address autofill reloads
    // providers there with the English name from our state list.
    if (stName) {
      lastApiParams.current.stName = stName;
      await dispatch(getStateDiscom(stName));
    }
    if (bindId !== bindInitialDataId.current) return;
    dispatch(setCountryName(countryName!));
    // dispatch(setRegionName(stName)); // select element instead 
    // dispatch(setProjectName(`PvNxtFP0${(projects?.length ?? 0) + 1}`));

    // dispatch(setProjectName(`pvNXT_${user?.fname}_FP0${(projects?.length ?? 0) + 1}`));
    // keep state/country in form to avoid being wiped by future setFormProjectSetup calls
    // Patch only the fields this flow owns — NoRoofModal writes address/lat/lng concurrently, and a full replace
    // from this (stale) snapshot or theirs would wipe the other's fields (e.g. country lost after delete + re-confirm)
    let patch: Partial<TProjectTypesNew> = { country: countryName!, totalroofarea: globalLayers.totalroofArea };
    if ((!projectSetup.totalroofarea || projectSetup.totalroofarea === 0) && globalLayers.totalroofArea > 0) {
      patch = { ...patch, useablearea: globalLayers.totalroofArea };
    }
    if (indiaData) {
      patch = { ...patch, state: indiaData.state, city: indiaData.district, pincode: indiaData.pincode };
    } else if (isIndia) {
      // No pincode match for this point: drop the previous site's city/pincode instead of showing them for this one
      patch = { ...patch, state: stName ?? "", city: "", pincode: "" };
    }
    dispatch(patchFormProjectSetup(patch));

    // Set Project Name here... 


    // dispatch(setProjectName(`pvNXT_${user?.fname}_FP0${(projects?.length ?? 0) + 1}`));
    // debugger
    // dispatch(setProjectName(generateProjectName(user?.fname,projectSetup?.state??"", projects?.length ?? 0)));
    bindMapInputAdress(address);
    setAddressLoading(false);
  };

  const bindProjectSetupData = async (projectDetails: ProjectTy) => {
    try {
      setAddressLoading(true);
      const stName = await getStateFromCoordinates(projectDetails.lng, projectDetails.lat);
      const countryName = await fetchCountryNamefromLatLng(projectDetails.lat, projectDetails.lng);
      dispatch(setCountryName(countryName!));
      dispatch(setRegionName(stName));
      bindMapInputAdress(projectDetails.address);

      const subStatus = projectDetails?.consumer_subprojectstatus ?? 0;
      const shouldFetchApi = subStatus !== 3 && subStatus >= 1;

      if (subStatus >= 3) {
        setCompletedStep(4)
        dispatch(setIsSubAccordianCompletedStep(4))
      }

      let currentAllDiscom = allDiscom;
      let currentProviderType = providertype;

      if (skipTariffFetchRef.current) {
        skipTariffFetchRef.current = false;
      } else if (shouldFetchApi) {
        // Use the saved site state (English, from our state list) — the map's region can be in the local language and 404s on the tariff API
        const discomStateName = projectDetails?.projectlocation?.state || stName;
        if (lastApiParams.current.stName !== discomStateName) {
          const { payload } = await dispatch(getStateDiscom(discomStateName));
          currentAllDiscom = payload;
          lastApiParams.current.stName = discomStateName;
        }

        if (projectDetails.providerid && (lastApiParams.current.providerId !== projectDetails.providerid.value)) {
          const { payload } = await dispatch(getTerrifData((projectDetails.providerid as any)));
          currentProviderType = payload;
          lastApiParams.current.providerId = projectDetails.providerid.value as string;
        }
      }

      const state = projectDetails?.projectlocation?.state;
      if (shouldFetchApi && state && statesList?.length) {
        const selectedState = statesList.find(item => item?.state === state);
        if (selectedState?.stateid && lastApiParams.current.stateId !== selectedState.stateid) {
          debounceFetchSingleStDt(selectedState.stateid);
          lastApiParams.current.stateId = selectedState.stateid;
        }
      }

      let project = projectDetails;
      if (projectDetails.installationmode && projectDetails.consumerdetails) {
        project = typeof projectDetails.consumerdetails !== "string" ? projectDetails.consumerdetails : JSON.parse(projectDetails.consumerdetails)
      }
      // Completed projects skip the tariff fetch above, but the review still needs the provider list to name the saved provider
      const savedProviderId = project.providerid as any;
      if (savedProviderId && !filterKeyIncludeArr(currentAllDiscom, "providerid", savedProviderId).length) {
        const discomStateName = projectDetails?.projectlocation?.state || stName;
        const { payload } = await dispatch(getStateDiscom(discomStateName));
        if (Array.isArray(payload)) {
          currentAllDiscom = payload;
          lastApiParams.current.stName = discomStateName;
        }
      }
      await updateFromDetails(project, currentAllDiscom, currentProviderType);
    } catch (err: any) {
      console.log(err);
      toast.error(err, { autoClose: 7000 });
    } finally {
      // setIsLoading(false);
      setAddressLoading(false);
    }
  };
  const bindMapInputAdress = async (address: string) => { // for handling search element in header 
    setTimeout(() => {
      const inp = globalLayers.searchWidgetInput;
      if (inp && inp.container.querySelector(".esri-search__input") && address) {
        inp.container.querySelector(".esri-search__input").value = address;
        if (selected_project?.iscompleted) {
          inp.container.querySelector(".esri-search__input").disabled = true;
        }
      }
    }, 2000);
  };

  const [openAccordion, setOpenAccordion] = useState<string | null>("roofspec");
  const [qpaIsLoading, setQPAIsLoading] = useState<boolean>(false);
  const [isConfimModal, setIsConfimModal] = useState(false);

  const saveProjectDetails = async (projectid?: string, quickplantanalysis?: boolean) => {
    // selected_project is briefly null while the new project is re-fetched; reuse the id we just
    // created (if it's still the active one) so that save updates instead of creating a duplicate
    if (!projectid && createdProjectIdRef.current && sessionStorage.getItem("projectid") === createdProjectIdRef.current) {
      projectid = createdProjectIdRef.current;
    }
    // Only one create at a time; a parallel one would make a second project
    if (!projectid) {
      if (creatingProjectRef.current) return;
      creatingProjectRef.current = true;
    }

    let projectName = generateProjectName(user?.fname, projectSetup?.state ?? "", projects?.length ?? 0)

    setQPAIsLoading(true)
    try {

      const computedCapacity = computeCapacity((projectSetup?.useablearea || 0 > 0) ? +projectSetup?.useablearea?.toFixed(2) : +projectSetup?.totalroofarea?.toFixed(2));
      let reqBody = {
        // projectname: projectSetup.projectname,
        projectname: projectName,
        projecttype: projectSetup.projecttype?.value,
        address: projectSetup.address,
        userid: user.userid,
        sanctionload: projectSetup.sanctionload,
        is3droofavailable: selected_project?.is3droofavailable ?? is3ddata ?? false,
        // electricityrate: +currencyConverter(user.country_mstr, projectSetup.electricityrate, true, true),
        electricityrate: +projectSetup.electricityrate,
        useablearea: projectSetup.useablearea,
        lat: projectSetup.lat,
        lng: projectSetup.lng,
        gridtype: projectSetup?.gridtype?.value,
        totalroofarea: projectSetup.totalroofarea,
        projectcost: quickplantAnalysis.costbracket.toString() === "" ? selected_project?.projectcost?.toString() : quickplantAnalysis.costbracket.toString(),
        providerid: projectSetup.providerid?.value,
        consumercategoryid: projectSetup.consumercategoryid?.value,
        graphicLayer: isWithRoof ? JSON.stringify(globalLayers.selectedGraphic) : "",
        // plantcapacity: (convertACtoDC(projectSetup?.sanctionload) ?? "0"),
        monthlyunit: projectSetup.monthlyunit ? Number(projectSetup.monthlyunit) : 0 as number,
        // usable area not working from globallayer
        //  plantCap = Math.round((useablearea * coverageFactor * voltagepermodule) / ((defaultmoduleWidth * defaultmoduleLength) * 1000))
        // maxplantcapacity: projectSetup?.plantcapacity === 0 ? Math.round(((selected_project?.useablearea ?? 0) * coverageFactor * voltagepermodule) / ((defaultmoduleWidth * defaultmoduleLength) * 1000)) ?? 0 : projectSetup?.plantcapacity ?? 0,
        // maxplantcapacity: (convertACtoDC(projectSetup?.sanctionload) ?? "0"),
        maxplantcapacity: null,
        ...getCapacityFields(projectSetup.sanctionload, selected_project),
        createdby: user.userid,
        consumerdetails: {},
        // consumer_projectstatus: selected_project?.consumer_projectstatus === 0 ? selected_project?.consumer_projectstatus + 1 : selected_project?.consumer_projectstatus ?? 0,
        consumer_subprojectstatus: (selected_project?.consumer_subprojectstatus || 0) === 0 ? 1 : quickplantanalysis && selected_project?.consumer_subprojectstatus === 1 ? 2 : selected_project?.consumer_subprojectstatus,
        projectlocation: {
          // houseblock: projectSetup.houseblock,roadarea:projectSetup.roadarea,
          address: projectSetup.addressline1,
          city: projectSetup.city,
          state: projectSetup.state,
          country: projectSetup.country,
          pincode: projectSetup.pincode
        }
      };
      // debugger
      // const { inverter, module } = await fetchPANOND();
      // dispatch(setOndFiles({ inverter, module }));
      // usable area not working from globallayer
      // reqBody.plantcapacity = Math.round((reqBody?.usablearea * coverageFactor * voltagepermodule) / ((defaultmoduleWidth * defaultmoduleLength) * 1000));
      // reqBody.plantcapacity = Math.round((reqBody?.useablearea * coverageFactor * voltagepermodule) / ((defaultmoduleWidth * defaultmoduleLength) * 1000));
      // reqBody.plantcapacity = reqBody?.plantcapacity;
      reqBody.maxplantcapacity = null;
      globalLayers.plantcapacity = Number(reqBody.sanctionload);
      globalLayers.isSavedProject = true;
      const consumerDetails = selected_project?.consumerdetails && typeof selected_project.consumerdetails === 'string' ? JSON.parse(selected_project.consumerdetails) : selected_project?.consumerdetails || {};
      if (selected_project && selected_project.consumerdetails) {
        reqBody.consumerdetails = JSON.stringify({
          ...consumerDetails,
          ...reqBody,
        });
      } else {
        reqBody.consumerdetails = JSON.stringify(reqBody);
      }

      const { payload }: any = await dispatch(saveConsumerProjects({ reqBody, projectid }));
      if (typeof payload === "string") {
        throw new Error("Something went wrong to save or update projects")
      }
      if (payload) {
        if (payload.code && payload.code !== "200") {
          toast.error(payload.response?.data.message ?? payload.message, { toastId: "customID", autoClose: 7000 });
          return;
        };
        globalLayers.selected_project = payload
        toast.success(`The project setup has been successfully ${projectid ? "updated" : "saved"}`, { toastId: "customID", autoClose: 7000 });

        if (!projectid) {
          let projects: ProjectTy[] = []
          if (user.projects?.length) {
            projects = [...user.projects!, payload]
          } else {
            projects = [payload];
          }
          dispatch(setUserProjects(projects));
        }

        sessionStorage.setItem("projectid", payload.projectid);
        if (!projectid) createdProjectIdRef.current = payload.projectid;
        //nextModal
        if (openAccordion === "roofspec") {
          // setOpenAccordion(null);
          setOpenAccordion("projectsetup")
        } else if (openAccordion === "projectsetup") {
          setOpenAccordion("quickplantanalysis")
        }

      }
    } catch (err) {
      console.log(err);
    } finally {
      setQPAIsLoading(false)
      if (!projectid) creatingProjectRef.current = false;
    }
    globalLayers.stopSketch()
  };

  // bind initial data on mount or reload of page 
  const updateFromDetails = async (projectDetails: ProjectTy, discom: IallTypestate[], providertype: ITariffType[]) => { // updating  form data
    const providerid = projectDetails.providerid ? { label: getElementByIndex(filterKeyIncludeArr(discom, "providerid", (projectDetails.providerid as any)), 0, "providername"), value: (projectDetails.providerid as any) } : null;
    const consumercategoryid = projectDetails.consumercategoryid ? { label: getElementByIndex(filterKeyIncludeArr(providertype, "consumercategoryid", (projectDetails.consumercategoryid as any)), 0, "consumercategoryname"), value: (projectDetails.consumercategoryid as any) } : null;
    // debugger
    dispatch(setFormProjectSetup({
      ...projectSetup, address: projectDetails.address, projectname: projectDetails.projectname, projectid: projectDetails.projectid, lat: projectDetails.lat, lng: projectDetails.lng,
      electricityrate: projectDetails?.electricityrate, sanctionload: projectDetails?.sanctionload, useablearea: projectDetails.projecttype?.value === "RCC Flat" ? projectDetails.useablearea : projectDetails.useablearea,
      totalroofarea: projectDetails.totalroofarea, providerid, consumercategoryid, projecttype: { label: (projectDetails.projecttype as any), value: (projectDetails.projecttype as any) },
      plantcapacity: projectDetails.plantcapacity, monthlyunit: projectDetails.monthlyunit !== null ? projectDetails.monthlyunit : 0,
      state: projectDetails.projectlocation?.state ?? regionName, country: projectDetails?.projectlocation?.country ?? countryName, city: selected_project?.projectlocation?.city ?? '',
      roadarea: selected_project?.projectlocation?.roadarea ?? '', pincode: selected_project?.projectlocation?.pincode ?? '', houseblock: selected_project?.projectlocation?.houseblock ?? '',
      addressline1: selected_project?.projectlocation?.address ?? '',
      gridtype: selected_project?.gridtype ? { label: selected_project?.gridtype, value: selected_project?.gridtype } : null as any
      // location
      // state:projectDetails.state??regionName,
      // country:projectDetails.country??countryName,
    }));
    // debugger
    if (projectDetails.graphicLayer !== '') { dispatch(setIsBuildingDrawn(true)) }
  };

  const debounceFetchSingleStDt = useDebounce((stateid: string) => { dispatch(getDistrictListByStateID([stateid])) }, 1000);

  const updateErrorFields = (fieldNames: string[]) => {
    let updatedErrors = { ...error };
    for (let fieldName of fieldNames) {
      if (updatedErrors[fieldName]) {
        delete updatedErrors[fieldName];
        updatedErrors = { ...updatedErrors };
      };
    }
    dispatch(setRoofDetailsError(updatedErrors));
  };

  const handleChange = useCallback((props: any, selectedOption?: any) => {
    const target = props?.target ?? props;
    // debugger
    let { name, value, type, maxLength } = target;
    if (selectedOption) {
      name = selectedOption.name;
      value = props;
    }
    if (["state", "city", "pincode"].includes(name)) {
      addressEditRevision.current += 1;
      lastAutofilledLocation.current = `${selected_project?.projectid ?? projectSetup.createdId ?? "new"}:${lat},${lng}`;
    }
    dispatch(setRoofDetailsError({}));
    projectSetupUpdated.current = true

    // const invalidCharPattern = /[eE+\-\s]/; // includes space
    // Only process type="number"
    if (type === "number") { // Check if the type string is "number"
      value = String(value)

      if (maxLength) {
        // Keep only digits
        const digitsOnly = value.replace(/\D/g, "");
        // Remove leading zeros
        const cleanedValue = digitsOnly.replace(/^0+/, "");
        // Enforce maxLength (uncommented if you want this active)
        if (cleanedValue.length > maxLength) {
          console.log("Input exceeds maxLength. Blocking entry.");
          return;
        }
        value = cleanedValue;
      }
      value = Number(value);
    }

    if ((name === "addressline1" || name === "city") && value.length > 100) {
      return
    }
    if (name === "city") {
      value = value.label;
      // value = capitalizeFirstLetter(value)
    }
    let isStateChanged = false;
    if (name === "state") {
      debounceFetchSingleStDt(value.value);
      // Electricity providers are per state — reload them for the newly selected state
      if (value.label !== projectSetup.state) {
        isStateChanged = true;
        dispatch(getStateDiscom(value.label));
        lastApiParams.current.stName = value.label;
      }
      value = value.label;
    }
    if (name === "pincode") {
      value = normalizeCountryPostalInput(String(value), siteCountry);
    }

    let updatedSetup = { ...projectSetup, [name]: value ?? props! };
    if (name === "state") { updatedSetup = { ...updatedSetup, city: "" } }
    // The previous state's provider/category don't belong to the new state's provider list
    if (isStateChanged) { updatedSetup = { ...updatedSetup, providerid: null, consumercategoryid: null } }
    let errorFields = [name];
    dispatch(setFormProjectSetup(updatedSetup));
    updateErrorFields(errorFields);

    // Live feedback: show the country-specific length/format error as soon as the user has typed something
    if (name === "pincode" && value) {
      const postalError = validateCountryPostalCode(value, siteCountry);
      if (postalError) {
        dispatch(setRoofDetailsError({ ...error, pincode: postalError }));
      }
    }

    // Mark as updated if it differs from the last saved state
    // projectSetupUpdated.current = JSON.stringify(updatedSetup) !== initialFormState.current;

  }, [projectSetup, dispatch, countryName, error, siteCountry, checkPinLength]);

  useEffect(() => {
    // if (selected_project !== null) return;
    if (obsArea) {
      // debugger
      let usearea = obsArea
      if (is3ddata) {
        usearea = useableArea!
      }
      if (is3ddata || false) {
        dispatch(setFormProjectSetup({ ...projectSetup, useablearea: parseFloat(usearea), totalroofarea: parseFloat(obsArea), projecttype: { label: 'Hybrid', value: 'Hybrid' } as RoofType, state: regionName, country: countryName! }));
      } else {
        dispatch(setFormProjectSetup({ ...projectSetup, useablearea: parseFloat(usearea), totalroofarea: parseFloat(obsArea), projecttype: null, state: regionName, country: countryName! }));
      }
    };
    if (polygonDrawn.length && obsArea) {
      getCityFromCoordinates(lng!, lat!).then((city: string) => {
        dispatch(setCreatedId(newgeneratedId(city)));

        fetchCompleteAddress(lat, lng, true).then((ele: any) => {
          setTimeout(() => {
            const inp = globalLayers.searchWidgetInput;
            if (inp && inp.container.querySelector(".esri-search__input") && ele) {
              inp.container.querySelector(".esri-search__input").value = ele;
            }
          }, 2000);

          // let usearea = obsArea
          // if (is3ddata) {
          //   usearea = useableArea!
          // }
          // if (is3ddata) {
          //   dispatch(setFormProjectSetup({ ...projectSetup, useablearea: parseFloat(usearea), totalroofarea: parseFloat(obsArea), projecttype: { label: 'Hybrid', value: 'Hybrid' } as RoofType, state: regionName, country: countryName! }));
          // } else {
          //   dispatch(setFormProjectSetup({ ...projectSetup, address: ele, useablearea: parseFloat(usearea), totalroofarea: parseFloat(obsArea), projecttype: null, state: regionName, country: countryName! }));
          // }
        })
      });
    }
  }, [polygonDrawn, address, obsArea]);

  // console.log("State name    ==>>  ",projectSetup.state)
  // console.log("State name    ==>>  ",error)

  const validateSiteDetails = (postalCountry = siteCountry): boolean => {
    let isValid = true;
    const errors: Record<string, string> = {};
    const isProjectNameExists = projects?.some((ele: any) => ele.projectname === projectSetup.projectname);


    // Validate against the site's country (from the map), not the user's account country
    const postalError = validateCountryPostalCode(projectSetup.pincode, postalCountry);
    const validations = [
      { field: "address", condition: !projectSetup.address, message: "This field is required" },
      { field: "addressline1", condition: !projectSetup.addressline1, message: "This field is required" },
      { field: "city", condition: !projectSetup.city, message: "This field is required" },
      { field: "state", condition: !projectSetup.state, message: "This field is required" },
      // { field: "pincode", condition: !projectSetup.pincode, message: "This field is required" },
      { field: "pincode", condition: !!postalError, message: postalError ?? "This field is required" },
    ];
    // if (allDiscom.length > 0) {
    //     validations.push(
    //         { field: "providerid", condition: !projectSetup.providerid?.value, message: "This field is required" },
    //         { field: "consumercategoryid", condition: !projectSetup.consumercategoryid?.value, message: "This field is required" }
    //     );
    // };
    for (const { field, condition, message } of validations) {
      if (condition) {
        errors[field] = message;
        isValid = false;
      }
    }
    if (Object.keys(errors).length > 0) {
      dispatch(setRoofDetailsError(errors));
    };
    if (Object.keys(error).length > 0) {
      isValid = false; console.log("Error site details")
      Toast({ messageText: "Information is missing or incorrect. Please update and try again.", messageType: "E", autoClose: 3000, toastId: FORMTOASTERRID })
    }
    return isValid;
  };

  const validateForm = (): boolean => {

    let isValid = true;
    const errors: Record<string, string> = {};
    const isProjectNameExists = projects?.some((ele: any) => ele.projectname === projectSetup.projectname);
    const maxConnectedLoad = getMaxConnectedLoad(projectSetup.useablearea, projectSetup.totalroofarea);
    const validations = [
      { field: "address", condition: !projectSetup.address, message: "This field is required" },
      { field: "totalroofarea", condition: !projectSetup.totalroofarea, message: "This field is required" },
      // { field: "roadarea", condition: !projectSetup.roadarea, message: "This field is required" },
      // { field: "houseblock", condition: !projectSetup.houseblock, message: "This field is required" },
      { field: "addressline1", condition: !projectSetup.addressline1, message: "This field is required" },
      // { field: "state", condition: !projectSetup.state, message: "This field is required" },
      { field: "city", condition: !projectSetup.city, message: "This field is required" },
      // { field: "country", condition: !projectSetup.country, message: "This field is required" },
      { field: "pincode", condition: !projectSetup.pincode, message: "This field is required" },
      {
        field: "totalroofarea", condition: projectSetup.totalroofarea !== undefined && (projectSetup.totalroofarea < MINUSEABLEAREA || projectSetup.totalroofarea > MAXUSEABLEAREA), message: `Total roof area must be between  to  sq m`
      },
      { field: "projectname", condition: !projectSetup.projectname, message: "This field is required" },
      { field: "projecttype", condition: !projectSetup.projecttype || !projectSetup?.projecttype?.label, message: "This field is required" },
      { field: "sanctionload", condition: projectSetup.sanctionload <= 0 || !Number.isFinite(projectSetup.sanctionload), message: "This field is required" },
      { field: "sanctionload", condition: projectSetup.sanctionload > maxConnectedLoad, message: `Connected load must be at most ${maxConnectedLoad} kW for this roof area` },
      { field: "electricityrate", condition: !projectSetup.electricityrate, message: "This field is required" }
    ];
    if (allDiscom.length > 0) {
      validations.push(
        { field: "providerid", condition: !projectSetup.providerid?.value, message: "This field is required" },
        { field: "consumercategoryid", condition: !projectSetup.consumercategoryid?.value, message: "This field is required" }
      );
    };
    for (const { field, condition, message } of validations) {
      if (condition) {
        errors[field] = message;
        isValid = false;
      }
    }

    if (Object.keys(errors).length > 0) {
      dispatch(setRoofDetailsError(errors));
    };
    // debugger
    if (Object.keys(error).length > 0) {
      const updatedError = { ...error };
      //  debugger
      if (updatedError.sanctionload && projectSetup.sanctionload > 0 && projectSetup.sanctionload <= maxConnectedLoad) {
        delete updatedError.sanctionload;
      }
      Object.assign(updatedError, errors);
      dispatch(setRoofDetailsError(updatedError));
      if (Object.keys(updatedError).length > 0) {
        isValid = false;
        console.log("Error site details")
        Toast({ messageText: "Information is missing or incorrect. Please update and try again.", messageType: "E", autoClose: 3000, toastId: FORMTOASTERRID });
      }
    }
    return isValid;
  };

  const [summaryLoading, setSummaryLoading] = useState(false);

  const handleFooterNxtBtn = async (btnTitle: btnTitleTypeCustomer) => {
    // debugger
    dispatch(toogleTooltip({ dipy: 0, istooltip: "", msg: "" }))
    switch (btnTitle) {
      case "Site Details": {
        // Ignore repeat clicks: a second click while the first is saving would create a second project
        if (addressSavingRef.current) return;
        addressSavingRef.current = true;
        // Show the loader from the first click, including while the country list loads
        setAddressModalBtnLoading(true)
        try {
          let postalCountry = siteCountry;
          if (!countries.length) {
            try {
              const list = await loadCountryMaster();
              if (!list.length) throw new Error('Country list is empty');
              postalCountry = findCountryMaster(list, projectSetup.country || countryName);
            } catch {
              dispatch(setRoofDetailsError({ ...error, pincode: 'Postal code rules are unavailable. Please try again.' }));
              return;
            }
          }
          if (!validateSiteDetails(postalCountry)) return;

          // OPTIMIZATION: Only call API if data actually changed
          if (projectSetupUpdated.current || !selected_project) {
            await saveProjectDetails(selected_project?.projectid ?? "");
            initialFormState.current = JSON.stringify(projectSetup);
          }
        } finally {
          addressSavingRef.current = false;
          setAddressModalBtnLoading(false)
        }
        openViewProfileModal(null)
        // console.log("current step ref and current step  --->> ",completedStep ,"   -->>  ",(selected_project?.consumer_subprojectstatus ?? 0))

        if ((selected_project?.consumer_subprojectstatus ?? 0) <= 1 && (completedStep ?? 1) < 1) {
          roofDetailsModalTimeOutRef.current = setTimeout(() => openViewProfileModal("roofdetails"), 2000)
          // debugger
        }

        if ((currentStepRef.current ?? 1) === 4) {
          dispatch(setIsSubAccordianCompletedStep(4))
          setCurrentStep(4)
        }

        break
      }

      case "Quick Plant Analysis": {
        if (!validateForm()) return;
        dispatch(setIsSubAccordianCompletedStep(4));
        setCompletedStep(4);
        // If already calculated and no changes made, just show the modal
        // Reuse only when the shown estimate was computed from exactly the current load / rate / location / area
        if (!projectSetupUpdated.current && quickplantAnalysis?.electricityGenerated2 && isEstimateCurrent(selected_project?.projectid, projectSetup)) {
          openViewProfileModal("solarsummary");
          return;
        }

        setSummaryLoading(true);
        skipTariffFetchRef.current = true;
        const payload = await saveProjectDetails(selected_project?.projectid ?? "", true);

        // projectSetupUpdated.current = false; // Reset after successful save
        openViewProfileModal("solarsummary");
        const delay = (ms: any) => new Promise(resolve => setTimeout(resolve, ms));
        await delay(5000)
        setSummaryLoading(false);

        break;
      }
      case "Project Summary": {
        if (selected_project?.installationmode) {
          toast.info("An order has already been placed for this project.", { toastId: "", autoClose: 7000 });
          // toast.info("You have already placed an order for this existing Project.", { toastId: "" })
          return;
        };
        dispatch(setModalHeaderFooter({ title: "Confirm The Action", btnTxt: "Proceed", secondaryBtnTxt: "" }));
        setIsConfimModal(true);
        break;
      };
      case "Proceed": {
        if (selected_project?.installationmode) {
          toast.info("An order has already been placed for this project.", { toastId: "", autoClose: 7000 });

          return;
        };

        openViewProfileModal(null)
        dispatch(setModalHeaderFooter({ title: "How would you like to install your solar system?", btnTxt: "", secondaryBtnTxt: "", modalid: "finalproject", isheader: true }));
        setIsConfimModal(true);

        break;
      };
    };
  };


  const handleBackAndRevert = (backType: "editaddressback" | null) => {
    if (projectSetupSnapshot.current) {
      // Dispatch the snapshot back to the reducer to overwrite the "dirty" changes
      dispatch(resetDirtyAddress(projectSetupSnapshot.current));
      projectSetupSnapshot.current = null;
    }
    if (backType === "editaddressback") {
      openViewProfileModal("editaddressback")
    } else {
      openViewProfileModal(null);
    }
  };

  const handleAddressFinal = async () => {
    await handleFooterNxtBtn("Site Details")
    openViewProfileModal("editaddressback")
  }



  const [openSubAccordian, setOpenSubAccordian] = useState({ RoofDetails: false, YourSolarSummary: false })
  type leadinfoty = "pvnxt" | "installer" | false;
  const [addressEditModal, setAddressEditModal] = useState({ editAddress: false, message: "", success: false })
  const [roofDetailsModal, setRoofDetailsModal] = useState({ roofdetails: false, message: "", success: false })
  const [solarSummaryModal, setSolarSummaryModal] = useState({ solarsummary: false, message: "", success: false })
  const [leadInfoModal, setLeadInfoModal] = useState<{ leadinfo: leadinfoty; message: string; success: boolean; }>({ leadinfo: false, message: "", success: false })

  const openViewProfileModal = (modalTy: "editAddress" | "roofdetails" | "solarsummary" | "editaddressback" | null) => {
    // debugger
    setAddressEditModal({ editAddress: false, message: "", success: false })
    setRoofDetailsModal({ roofdetails: false, message: "", success: false })
    setSolarSummaryModal({ solarsummary: false, message: "", success: false })
    let modalHeaderFooter = { title: "", btnTxt: "", secondaryBtnTxt: "", modalid: "", tooltipId: "" }

    if (modalTy === "editAddress" || modalTy === "roofdetails") {
      // Take a deep copy of the current REDUX state as it stands right now
      projectSetupSnapshot.current = {
        city: projectSetup?.city ?? "", state: projectSetup?.state ?? "",
        country: projectSetup?.country ?? "", pincode: projectSetup?.pincode ?? "", addressline1: projectSetup?.addressline1 ?? ""
      };
    }

    dispatch(setModalHeaderFooter(modalHeaderFooter))
    switch (modalTy) {
      case "editAddress":
        modalHeaderFooter = { title: "Site Address", btnTxt: "Save Address", secondaryBtnTxt: "Back", modalid: "siteaddress", tooltipId: "" }
        setAddressEditModal({ editAddress: true, message: "", success: false })
        break
      case "roofdetails":
        modalHeaderFooter = { title: "Roof Details", btnTxt: "", secondaryBtnTxt: "Back", modalid: "roofdetails", tooltipId: "" }
        setRoofDetailsModal({ roofdetails: true, message: "", success: false })
        break
      case "solarsummary":
        modalHeaderFooter = { title: "Your solar summary", btnTxt: "", secondaryBtnTxt: "", modalid: "", tooltipId: "projectSummary" }
        setSolarSummaryModal({ solarsummary: true, message: "", success: false })
        break
      case "editaddressback":
        setAddressEditModal({ editAddress: false, message: "", success: false })
        modalHeaderFooter = { title: "Roof Details", btnTxt: "", secondaryBtnTxt: "Back", modalid: "roofdetails", tooltipId: "" }
        setRoofDetailsModal({ roofdetails: true, message: "", success: false })
        // dispatch(setAddressLine(selected_project?.projectlocation?.address ?? ""))
        // setSolarSummaryModal({ solarsummary: false, message: "", success: false })
        break;
      case null:
        setAddressEditModal({ editAddress: false, message: "", success: false })
        setRoofDetailsModal({ roofdetails: false, message: "", success: false })
        setSolarSummaryModal({ solarsummary: false, message: "", success: false })
        // dispatch(setAddressLine(selected_project?.projectlocation?.address ?? ""))
        modalHeaderFooter = { title: "", btnTxt: "", secondaryBtnTxt: "", modalid: "", tooltipId: "" }
        break;
      default:
        break
    }
    dispatch(setModalHeaderFooter(modalHeaderFooter))
    setAddressEditModal(prev => ({ ...prev, [modalTy as keyof object]: true }))
  }


  /* ─── Top stepper (Roof Confirmation → Review & submit) ─── */

  const validateStep = (step: number): boolean => {
    let isValid = true;
    const errors: Record<string, string> = {};

    if (step === 1) {
      if (!projectSetup.projectname) { errors["projectname"] = "This field is required"; isValid = false; }
      if (!projectSetup.totalroofarea) { errors["totalroofarea"] = "This field is required"; isValid = false; }
      else if (projectSetup.totalroofarea < MINUSEABLEAREA || projectSetup.totalroofarea > MAXUSEABLEAREA) {
        errors["totalroofarea"] = `Total roof area must be between  to  sq m`; isValid = false;
      }
      if (!projectSetup.projecttype || !projectSetup.projecttype.label) { errors["projecttype"] = "This field is required"; isValid = false; }
    }

    if (step === 2) {
      const maxConnectedLoad = getMaxConnectedLoad(projectSetup.useablearea, projectSetup.totalroofarea);
      if (projectSetup.sanctionload <= 0 || !Number.isFinite(projectSetup.sanctionload)) {
        errors.sanctionload = "This field is required";
        isValid = false;
      } else if (projectSetup.sanctionload > maxConnectedLoad) {
        errors.sanctionload = `Connected load must be at most ${maxConnectedLoad} kW for this roof area`;
        isValid = false;
      }
    }

    if (step === 3) {
      if (allDiscom.length > 0) {
        if (!projectSetup.providerid?.value) { errors["providerid"] = "This field is required"; isValid = false; }
        if (!projectSetup.consumercategoryid?.value) { errors["consumercategoryid"] = "This field is required"; isValid = false; }
      }
      if (!projectSetup?.electricityrate) { errors["electricityrate"] = "This field is required"; isValid = false; }
    }

    if (Object.keys(errors).length > 0) {
      dispatch(setRoofDetailsError(errors));
      Toast({ messageText: "Information is missing or incorrect. Please update and try again.", messageType: "E", autoClose: 3000, toastId: FORMTOASTERRID });
    }
    return isValid;
  }

  const handleModalNext = () => {
    if (validateStep(currentStep)) {
      if (currentStep < 3) {
        if (currentStep > completedStep) {
          dispatch(setIsSubAccordianCompletedStep(currentStep))
          setCompletedStep(currentStep);
          if (currentStepRef.current !== null && currentStepRef.current < 3) {
            currentStepRef.current = (currentStep) as ProposalStep;
          }
        }
        setCurrentStep(prev => (prev + 1) as ProposalStep);
      } else if (currentStep === 3) {
        dispatch(setIsSubAccordianCompletedStep(3))
        setCompletedStep(3);
        setCurrentStep(4);
        if (currentStepRef.current !== null) {
          currentStepRef.current = 4;
        }
      } else {
        if (!validateStep(2)) {
          setCurrentStep(2);
          currentStepRef.current = 2;
          return;
        }
        handleFooterNxtBtn("Quick Plant Analysis");
        // openViewProfileModal("solarsummary")
      }
    }
  };

  const handleModalBack = () => {
    dispatch(setRoofDetailsError({}));
    if (currentStep > 1) {
      setCurrentStep((prev: any) => (prev - 1) as any);
    } else {
      openViewProfileModal(null);
    }
  };


  const finalprojectiscompleted = async () => {
    try {
      setSaveButtonLoading(true)
      if (selected_project && Object.keys(selected_project).length > 0) {
        let reqBody: any = { iscompleted: true, consumer_mainprojectstatus: selected_project?.consumer_mainprojectstatus === 0 ? 1 : selected_project?.consumer_mainprojectstatus };
        const payload = await dispatch(saveConsumerProjects({ reqBody, projectid: selected_project.projectid }));
        //  debugger
        if ((payload as any)?.meta?.requestStatus === "fulfilled") {
          Toast({ messageText: "Project completed successfully from consumer", messageType: "S", toastId: FORMTOASTERRID });
        } else {

        }
      }
    } catch (error) {
      Toast({ messageText: "Failed to completed project!", messageType: "E", toastId: FORMTOASTERRID });
    } finally {
      setSaveButtonLoading(false)
    }

  }

  const handleOpenConfirm = () => {
    // debugger
    dispatch(setButtonLoader("loading3d"))
    if (is3dpayment != true) {
      dispatch(setModalHeaderFooter({ title: "Upgrade to 3D Roof Analysis", btnTxt: "Proceed To Payment", secondaryBtnTxt: "Cancel", isheader: true }));
      setAnalysisConfirm(true)
      // dispatch(set3dpayment(true))
    } else {
      fetchIframeAnalysis()
    }
  }

  const handleStepCompleteWarn = (type: "RoofDetails" | "YourSolarSummary") => {
    switch (type) {
      case "RoofDetails": Toast({ messageText: "Please complete the site address to proceed.", messageType: "E", toastId: FORMTOASTERRID })
        break
      case "YourSolarSummary":
        Toast({ messageText: "Please complete the roof details to proceed.", messageType: "E", toastId: FORMTOASTERRID })
        break
      default:
        break
    }
  }

  // Change installationmode from self mode to pvNxt

  const handleChangeInstallationMode = () => {
    dispatch(setModalHeaderFooter({ title: "Change your installation option", btnTxt: "", secondaryBtnTxt: "", modalid: "installationmodetopvnxt", isheader: true }));
  }

  // console.log(" selected project status : ->   ",selected_project?.consumer_subprojectstatus)
  const RoofDetailsCards = [{
    id: "no1", title: "ROOF DETAILS", onclick: () => openViewProfileModal("roofdetails"), isOpen: false, children: <></>, disable: (selected_project?.consumer_subprojectstatus ?? 0) < 1 ? true : false,
    isDisableClick: (selected_project?.consumer_subprojectstatus ?? 0) < 1 ? () => handleStepCompleteWarn("RoofDetails") : undefined,
    activeColor: ((selected_project?.consumer_subprojectstatus ?? 0) >= 1) && ((selected_project?.consumer_subprojectstatus ?? 0) < 3)
  },
  {
    id: "no2", title: "YOUR SOLAR SUMMARY", onclick: () => openViewProfileModal("solarsummary"), activeColor: false, isDisableClick: (selected_project?.consumer_subprojectstatus ?? 0) < 3 ? () => handleStepCompleteWarn("YourSolarSummary") : undefined,
    isOpen: false, disable: ((selected_project?.consumer_subprojectstatus ?? 0) < 3 ? true : false)
  }
  ]

  // {id:"no2",title:"YOUR SOLAR SUMMARY",onclick:()=>setOpenSubAccordian(prev=>({...prev,YourSolarSummary:!openSubAccordian.YourSolarSummary})), isDisableClick: (selected_project?.consumer_subprojectstatus ?? 0) < 3 ? () => handleStepCompleteWarn("YourSolarSummary") : undefined,
  // isOpen:openSubAccordian.YourSolarSummary,children:<>{<SolarSummaryContent />}</>,disable:((selected_project?.consumer_subprojectstatus ?? 0) < 3 ? true : false)}

  const handleStepClick = useCallback((step: ProposalStep) => {
    // if(((selected_project?.consumer_subprojectstatus?? 0) >= 3))return;
    if (step > currentStep) {
      for (let priorStep = currentStep; priorStep < step; priorStep++) {
        if (!validateStep(priorStep)) {
          setCurrentStep(priorStep as ProposalStep);
          currentStepRef.current = priorStep as ProposalStep;
          return;
        }
      }
    }
    setCurrentStep(step);
    currentStepRef.current = step;
  }, [currentStep, validateStep]);


  const cardRightContent = () => {
    return (<>
      <div className="relative inline-flex">
        {/* Glow layer */}
        {(selected_project?.consumer_subprojectstatus ?? 0) < 1 && <span className="absolute inset-0  bg-custom-primary-dark opacity-0 rounded-full animate-pulse-glow"></span>}

        <button type="button" onClick={() => openViewProfileModal("editAddress")} className="relative bg-[#F4F4F5] rounded-full size-5 flex items-center justify-center "  >
          <EditIcon />
        </button>
      </div>
    </>)
  }

  const cardChildren = () => (
    <div className="flex w-full text-sm text-gray-700 gap-3">
      <div className="mt-[2px]" >  <LocationIcon /> </div>
      <div className="pr-2 overflow-hidden w-full">
        {/* <h4 className='heading-14-roboto-normal text-nowrap overflow-hidden text-ellipsis h-5'>{projectSetup?.addressline1 || projectSetup.address}</h4> */}
        <h4 className='heading-14-roboto-normal text-nowrap overflow-hidden text-ellipsis h-5'>{selected_project?.projectlocation?.address || projectSetup.address}</h4>
        <div className='w-full flex items-center gap-1'>
          <p className="text-12-roboto leading-normal h-4">{projectSetup?.state ? `${projectSetup?.city}, ${projectSetup?.state}, ${projectSetup?.country}, ${projectSetup?.pincode}` : ``} </p>
        </div>
      </div>
    </div>
  )

  // console.log("complete sub steps ===>>   ",isSubAccordianCompletedStep)
  // console.log("current ----- sub steps ===>>   ",currentStep)
  // console.log("currentref sub steps ===>>   ",currentStepRef)

  return (<>
    <ReactTooltip id="useraddresstooltip" Side="LSB" place="right" content="Verify or update your site address details here." />
    {(modalid === "siteaddress") && createPortal(<NewModal isBack scrollhide maxheight="70vh" outlinelefticon={<BackBoxIcon />} isLoading={addressModalBtnLoading} primarylefticon={<IconSave />} modalSize="sm" isAbleCLick btnName=""
      onClick={() => handleFooterNxtBtn("Site Details")} setIsCLose={() => handleBackAndRevert(null)} name={"Site Address"} hidPrimaryBtn={(selected_project?.consumer_subprojectstatus ?? 0) >= 3}
      children={<>
        <div className="pb-4">
          <div className="grid grid-cols-1 p-1 gap-x-2 gap-y-2 w-[28rem]">
            <Input smpadding id={"Country"} isRequired isBtnLoading={addressLoading} label={`Country`} name={"country"} /* value={countryName} */ value={projectSetup.country} error={error?.country} type={"text"} onChange={() => { }} disabled={true} />
            <ReactSelect smpadding menuPlacement="bottom" isLoading={addressLoading} isrequired isSearchable={true} error={error.state} onChange={handleChange} options={statesList.map(item => ({ label: item.state, value: item.stateid }))} value={projectSetup.state === "" ? null : { label: projectSetup.state, value: projectSetup.state }} closeMenuOnSelect key="state" labelname="State/Province/Region" name="state" placeholder="Select an option" disabled={(selected_project?.consumer_subprojectstatus ?? 0) >= 3} /* disabled={isIndiaAddressAutoPopulated || (selected_project?.consumer_projectstatus?? 0) >=3} */ />
            <ReactSelect smpadding menuPlacement="bottom" isLoading={addressLoading} isrequired isSearchable={true} error={error.city} onChange={handleChange} options={districtsList.map(item => ({ label: item.district, value: item.district }))} value={projectSetup.city === "" ? null : { label: projectSetup.city, value: projectSetup.city }} closeMenuOnSelect key="city" labelname="District/City" name="city" placeholder="Select an option" disabled={districtsList?.length === 0 || (selected_project?.consumer_subprojectstatus ?? 0) >= 3} />
            <Input smpadding isRequired isBtnLoading={addressLoading} disabled={(selected_project?.consumer_subprojectstatus ?? 0) >= 3} id={"Zip/Pin code"} label={`Zip/Postal code`} name={"pincode"} maxLength={checkPinLength} value={projectSetup.pincode} error={error?.pincode} type={"text"} onChange={handleChange} />
            <GTextareaCom smpadding disabled={(selected_project?.consumer_subprojectstatus ?? 0) >= 3} max={`100 words | ${projectSetup.addressline1?.length || 0} / 100 `} helpertext={`H No/Flat No, colony/building name, street name, area`} error={error?.addressline1}
              placeholder='Briefly describe your location ..' id={"AddressLine1"} label={"Street address"} name={"addressline1"} value={capitalizeFirstLetterOnly(projectSetup.addressline1)}
              type="text" onChange={handleChange} isRequired={true} />
            <div className="p-0"></div>

            {/* <Input  disabled={selected_project?.iscompleted} id={"AddressLine1"} label={`Address line`} name={"addressline1"} value={capitalizedWordOfSentence(projectSetup.addressline1)} helpertext="H.NO,Street address,P.O Box,etc." error={error?.addressline1} type={"text"} onChange={handleChange}  />  */}
            {/* <Input id={"Site Location"} label={`Site location`} name={"sitelocation"} value={projectSetup.address} type={"text"} onChange={handleChange} disabled={true} /> */}
          </div>
        </div>
      </>} />, document.body)}
    {(modalid === "siteaddressback") && createPortal(<NewModal isBack scrollhide maxheight="70vh" isLoading={addressModalBtnLoading} outlinelefticon={<BackBoxIcon />} primarylefticon={<IconSave />} modalSize="sm" isAbleCLick btnName=""
      onClick={() => handleAddressFinal()} setIsCLose={() => handleBackAndRevert("editaddressback")} name={"Site Address"} hidPrimaryBtn={(selected_project?.consumer_subprojectstatus ?? 0) >= 3}
      children={<>
        <div className="pb-4">
          <div className="grid grid-cols-1 p-1 gap-x-2 gap-y-2 w-[28rem]">
            <Input smpadding id={"Country"} isRequired isBtnLoading={addressLoading} label={`Country`} name={"country"} /* value={countryName} */ value={projectSetup.country} error={error?.country} type={"text"} onChange={() => { }} disabled={true} />
            <ReactSelect smpadding menuPlacement="bottom" isLoading={addressLoading} isrequired isSearchable={true} error={error.state} onChange={handleChange} options={statesList.map(item => ({ label: item.state, value: item.stateid }))} value={projectSetup.state === "" ? null : { label: projectSetup.state, value: projectSetup.state }} closeMenuOnSelect key="state" labelname="State/Province/Region" name="state" placeholder="Select an option" disabled={(selected_project?.consumer_subprojectstatus ?? 0) >= 3} /* disabled={isIndiaAddressAutoPopulated || (selected_project?.consumer_projectstatus?? 0) >=3} */ />
            <ReactSelect smpadding menuPlacement="bottom" isLoading={addressLoading} isrequired isSearchable={true} error={error.city} onChange={handleChange} options={districtsList.map(item => ({ label: item.district, value: item.district }))} value={projectSetup.city === "" ? null : { label: projectSetup.city, value: projectSetup.city }} closeMenuOnSelect key="city" labelname="District/City" name="city" placeholder="Select an option" disabled={districtsList?.length === 0 || (selected_project?.consumer_subprojectstatus ?? 0) >= 3} />
            <Input smpadding isRequired isBtnLoading={addressLoading} disabled={(selected_project?.consumer_subprojectstatus ?? 0) >= 3} id={"Zip/Pin code"} label={`Zip/Postal code`} name={"pincode"} maxLength={checkPinLength} value={projectSetup.pincode} error={error?.pincode} type={"text"} onChange={handleChange} />
            <GTextareaCom smpadding disabled={(selected_project?.consumer_subprojectstatus ?? 0) >= 3} max={`100 words | ${projectSetup.addressline1?.length || 0} / 100 `} helpertext={`H No/Flat No, colony/building name, street name, area`} error={error?.addressline1}
              placeholder='Briefly describe your location ..' id={"AddressLine1"} label={"Street address"} name={"addressline1"} value={capitalizeFirstLetterOnly(projectSetup.addressline1)}
              type="text" onChange={handleChange} isRequired={true} />
            <div className="p-0"></div>

            {/* <Input  disabled={selected_project?.iscompleted} id={"AddressLine1"} label={`Address line`} name={"addressline1"} value={capitalizedWordOfSentence(projectSetup.addressline1)} helpertext="H.NO,Street address,P.O Box,etc." error={error?.addressline1} type={"text"} onChange={handleChange}  />  */}
            {/* <Input id={"Site Location"} label={`Site location`} name={"sitelocation"} value={projectSetup.address} type={"text"} onChange={handleChange} disabled={true} /> */}
          </div>
        </div>
      </>} />, document.body)}


    {modalid === "roofdetails" && createPortal(<NewModal scrollhide isLoading={summaryLoading} modelbtn={(selected_project?.consumer_subprojectstatus ?? 0) >= 3 ? "" : currentStep === 4 ? "Get Estimate" : "Save & Continue"} minHeight={currentStep === 2 ? "fit-content" : ""} maxheight="70vh"
      outlinelefticon={<BackBoxIcon />} primarylefticon={currentStep === 4 ? <SolarPowerIcon /> : <IconSave />} modalSize="lg" isAbleCLick btnName=""
      onClick={handleModalNext} setIsCLose={() => openViewProfileModal(null)} isFooterRequired={!((selected_project?.consumer_subprojectstatus ?? 0) >= 3)}
      onSecondaryClick={(selected_project?.consumer_subprojectstatus ?? 0) < 3 ? handleModalBack : () => openViewProfileModal(null)}
      name={"Roof Details"} children={<>
        <div>   <div>
          {/* <TopStepper  */}
          <ProgressStepper currentStep={currentStep} completedStep={isSubAccordianCompletedStep} clickDisable={false} // completedStep={completedStep} (selected_project?.consumer_subprojectstatus ?? 0 ) >=3 
            onStepClick={handleStepClick} />
        </div>
          <RoofDetails step={currentStep} completedstep={completedStep} />   </div>
      </>} />, document.body)}

    {solarSummaryModal?.solarsummary && createPortal(<NewModal scrollhide overflow={"visible"} maxheight="s" isLoading={summaryLoading} modalSize="sm" onClick={() => { }} btnName="" isFooterRequired={false}
      setIsCLose={() => openViewProfileModal(null)} name={"Your Solar Summary"} children={<>
        <div>
          <SolarSummary isLoading={summaryLoading} projectSetupUpdated={projectSetupUpdated} openViewProfileModal={openViewProfileModal} isCompleted={(selected_project?.consumer_subprojectstatus ?? 0) >= 3} saveProjectDetails={saveProjectDetails} />
        </div>   </>} />, document.body
    )}

    { }

    <div className='w-full pt-2 relative'>

      {/* status of lead... */}

      {/* Pending Status Banner */}
      {/* <Hourglass className="w-6 h-6 text-amber-600" /> bg-[#fffcf5] */}
      {/* {!selected_project?.isepccomplete && selected_project?.iscompleted && <div className="gap-4 p-3 mb-4 border border-gray-200 rounded-lg ">
          <div className="mt-1 flex gap-2 items-center">
          <HourglassIcon />
          <h3 className="heading-13-roboto-normal">
              {selected_project?.installationmode as INSTALLATION_MODE === "pvNXT Mode" ? "Preparing your final solar proposal.." : "Your lead has been shared with installers."}
          </h3>
          </div>
          <div>
            <p className="text-12-roboto mt-2">
              {selected_project?.installationmode as INSTALLATION_MODE === "pvNXT Mode" ?   (  <> Usually ready within 48 hours.{" "}
              <strong> EPC might contact you in between for additional information regarding  your project. </strong>{" "}  You'll be notified once it's ready.   </>  )
              : "Your request has been shared with verified installers. They will review your details and contact you with proposals tailored to your requirements."}
            </p>
          </div>
        </div>} */}

      {/* Global card  */}
      <GInfoCard noWrap title={<p className="text-12-roboto leading-none flex items-center gap-1 uppercase"> SITE ADDRESS <span data-tooltip-id="useraddresstooltip"> <InfoMark />   </span> </p>}
        rightContent={cardRightContent()} subtitle={"Auto-filled from your selected map location. You can edit if needed."}
        children={cardChildren()} />


      {/* body card sections */}
      <div className='pt-2 flex flex-col gap-2'>
        {RoofDetailsCards?.map((item, index) => (<Accordion isDisable={item.disable} activeColor={item?.activeColor} isDisableClick={item.isDisableClick} key={item.id} isOpen={item.isOpen} title={item.title} onToggle={item.onclick} children={item.children} maxh="fit-content" />))}
      </div>

      <div className="buttonspace"></div>

      {/* Action Bottom  */}

      <div className="flex flex-col gap-4">

        {/* {is3ddata &&  <Button className="primary-outline-btn md-btn" name={"3D View"} onClick={()=>handleOpenConfirm()} isLoading={buttonLoader === "loading3d"} disabled={isLoading || (selected_project?.consumer_subprojectstatus ?? 0) < 3}  />} */}
        {/* {!selected_project?.iscompleted &&  <Button LeftIcon={<IconSave color='white' />}   disabled={selected_project?.iscompleted || (selected_project?.consumer_subprojectstatus ?? 0) < 3}  isLoading={saveButtonLoading}  className="primary-btn w-full absolute bottom-2"  name={"Save & Continue"}  onClick={finalprojectiscompleted}  />}    */}
        {/* {selected_project?.installationmode as INSTALLATION_MODE === "Self Mode" && !selected_project?.project_generation_id &&
              <Button LeftIcon={<BackBoxIcon rotate90 />} disabled={false} isLoading={false} className="primary-btn w-full" name={"Change Installation Option"} onClick={handleChangeInstallationMode} />
        } */}
      </div>

    </div>
  </>
  );
};
export default memo(SiteAddress)


// const TopStepper = ({ currentStep, completedStep, onStepClick }: StepperProps) => {
//   return (
//     <div className="flex w-full bg-white px-5 pt-3 pb-2 gap-2">
//       {stepLabels.map((label, index) => {
//         const step = (index + 1) as ProposalStep;
//         const isCompleted = step <= completedStep;
//         const isActive = step === currentStep;
//         const isClickable = isCompleted || step === completedStep + 1;

//         return (
//           <div key={label} onClick={() => isClickable && onStepClick(step)} className={`flex flex-col gap-2 flex-1 ${isClickable ? 'cursor-pointer' : 'cursor-default'}`}>
//             <div className={["h-[4px] w-full transition-all duration-300", (isActive || isCompleted) ? "bg-custom-primary-dark" : "bg-gray-400",].join(" ")} />
//             <span className={["text-[11px] flex justify-center", (isActive || isCompleted) ? "text-custom-primary-dark" : "text-gray-400", isActive ? "font-semibold" : "font-normal",].join(" ")} >
//               {label}
//             </span>
//           </div>
//         );
//       })}
//     </div>
//   );
// }
